module.exports = __webpack_public_path__ + "static/img/3.3505873.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/3.jpg
// module id = Pkht
// module chunks = 0